import React, { Component } from "react";
import { Col, Form, FormText, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Constants } from "../libs/Constants";
import { convertToDollar } from "../libs/utils";
import "./ContributionType.scss";

export default class ContributionUpdateModal extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      modificationAllowed: true,
      errorMessage: null,
      newContribution: 0,
      oldContribution: 0,
      period: 0,
    };
  }
  handleChange(e) {
    let newContribution;
    if (e.target.id === "newcontribution") {
      newContribution = e.target.value;
    } else {
      newContribution = (this.props.salary * e.target.value) / 100;
    }
    this.setState({
      oldContribution: this.props.oldcontribution,
      newContribution: newContribution,
      period: this.props.period,
    });
    this.validateInput(Number(newContribution));
  }
  validateInput(newContribution) {
    //validate the inputs
    let errorMessage = null;
    let modificationAllowed = true;
    let oldContribution = convertToDollar(this.props.oldcontribution);
    if (newContribution) {
      if (newContribution === oldContribution) {
        errorMessage = `No change in Contribution.`;
        modificationAllowed = false;
      } else {
        switch (this.props.type) {
          case Constants.CONTRIBUTION_STATUS.DECREASE:
            if (newContribution > oldContribution) {
              errorMessage = `You have selected ${this.props.type}. New Contribution should be less than old Contribution.`;
              modificationAllowed = false;
            }
            break;
          case Constants.CONTRIBUTION_STATUS.INCREASE:
            if (newContribution < oldContribution) {
              errorMessage = `You have selected ${this.props.type}. New Contribution should be more than old Contribution.`;
              modificationAllowed = false;
            } else if (newContribution > this.props.maxcontribution) {
              errorMessage = `New contribution can not be more than Maximum contribution allowed`;
              modificationAllowed = false;
            }
            break;
        }
      }
    }
    this.setState({
      modificationAllowed: modificationAllowed,
      errorMessage: errorMessage,
    });
  }
  handleSave() {
    const item = this.state;
    this.props.saveDetails(item);
  }
  render() {
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Enter new contribution (in $) or Percentage of Salary (in %)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} controlId="salary" className="form-group">
            <Form.Label column sm="4">
              Annual Income
            </Form.Label>
            <Col sm="5">
              <InputGroup>
                <>
                  <InputGroup.Text id="basic-addon1">US$</InputGroup.Text>
                  <Form.Control value={this.props.salary} type="number" />
                </>
              </InputGroup>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            controlId="oldcontribution"
            className="form-group"
          >
            <Form.Label column sm="4">
              Old Contribution
            </Form.Label>
            <Col sm="5">
              <InputGroup>
                <InputGroup.Text id="basic-addon1">US$</InputGroup.Text>

                <Form.Control
                  value={convertToDollar(this.props.oldcontribution)}
                  type="number"
                />
              </InputGroup>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            controlId="newcontribution"
            className="form-group"
          >
            <Form.Label column sm="4">
              New Contribution
            </Form.Label>
            <Col sm="5">
              <InputGroup>
                <InputGroup.Text id="basic-addon1">US$</InputGroup.Text>

                <Form.Control
                  type="number"
                  value={this.state.newContribution}
                  onChange={this.handleChange}
                />
              </InputGroup>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="percentage" className="form-group">
            <Form.Label column sm="4">
              Percentage
            </Form.Label>
            <Col sm="5">
              <InputGroup>
                <Form.Control
                  value={this.props.percentage}
                  type="number"
                  onChange={this.handleChange}
                />
                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
              </InputGroup>
            </Col>
            {!this.state.modificationAllowed && this.state.errorMessage && (
              <FormText className="textError">
                {this.state.errorMessage}
              </FormText>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.handleSave}
            variant="primary"
            value={this.state.newContribution}
            disabled={!this.state.modificationAllowed}
          >
            Save Changes
          </Button>
          <Button onClick={this.props.onHide} variant="outline-cancel">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
